import * as Yup from 'yup';

import { ELoginMethod, ELoginType, OTP_LENGTH } from '@/config/auth';
import { EBusinessType, EYearsOfOperation } from '@/config/profile';

import {
  confirmBoolean,
  makeEnumString,
  newPassword,
  optionalString,
  requiredEmail,
  requiredPhone,
  requiredString,
} from './common';

export const usernameSchema = Yup.object({
  idType: makeEnumString(ELoginType).default(ELoginType.EMAIL),
  idValue: Yup.string().ensure().when('idType', {
    is: ELoginType.PHONE,
    then: requiredPhone,
    otherwise: requiredEmail,
  }),
}).required();

export const otpSchema = Yup.object({
  code: requiredString.test('otpLength', 'otpLength', (value) => value.length === OTP_LENGTH),
}).required();

// Sign up
export const enterPhoneSchema = Yup.object({
  phoneNumber: requiredPhone,
}).required();

// Sign in
export const signInSchema = Yup.object({
  ...usernameSchema.fields,

  grantType: makeEnumString(ELoginMethod).default(ELoginMethod.PWD),
  password: Yup.string().ensure().when('grantType', {
    is: ELoginMethod.PWD,
    then: requiredString,
  }),
}).required();

// Profile
export const personalInformationSchema = Yup.object({
  firstName: requiredString,
  lastName: requiredString,
  email: requiredEmail,
  password: Yup.string().when('isPasswordAdded', {
    is: true,
    otherwise: newPassword,
  }),
}).required();

export const businessInformationSchema = Yup.object({
  businessLegalName: requiredString,
  yearsOfOperation: makeEnumString(EYearsOfOperation),
  businessType: makeEnumString(EBusinessType),
  authorizedRepresentativeFlag: confirmBoolean,
}).required();

export const stationLocationSchema = Yup.object({
  streetAddress: requiredString,
  secondaryAddress: optionalString,
  city: requiredString,
  state: requiredString,
  zip: requiredString.max(5),
}).required();

// Forget password
export const createPasswordSchema = Yup.object({
  newPassword,
  confirmPassword: requiredString.oneOf([Yup.ref('newPassword'), ''], 'forgotPassword.dontMatch'),
}).required();
